export const rem = v => `${v}rem`
export default rem;



// WEBPACK FOOTER //
// ./src/theme/rem.js